import moment from 'moment-timezone';
import React from 'react';
import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import CardCollaboratorResume from '../../Cards/CardCollaboratorResume/CardCollaboratorResume';
import Tags from '../../Tags/Tags';
import ResultOrigin from '../ResultOrigin/ResultOrigin';

import classes from './CollaboratorsResult.module.scss';

import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';
import Tooltip from '../../Tooltip/Tooltip';
import { statusAccountTransaction } from '../../../store/constants/statusDruoAccounts';
import { accountSubTypeLabelObject } from '../../../store/catalogs/banks';

const CollaboratorsResult = ({ payPayrollData, showCollaborators, showDetailsCollaboratorUnique, view, methodForPay, costTransaction }) => {
  return (
    <>
      <span className='medium-14'>{moment(payPayrollData.creationDate).format('DD [de] MMMM [del] YYYY [a las] hh:mm a')}</span>
      <span className={`${classes.collaborators} medium-12`}>COLABORADORES</span>
      {payPayrollData.payouts.length > 1 ? (
        <div className={`${classes['card-collaborators']}`}>
          <div className={classes.space}>
            <span className='semibold-18'>{payPayrollData.payouts.length} colaboradores</span>
            <Tags
              text={statusAccountTransaction[payPayrollData.status].label}
              type={statusAccountTransaction[payPayrollData.status].color}
            />
          </div>
          <Button custom='quaternary' onClick={showCollaborators}>
            Ver detalles
          </Button>
        </div>
      ) : (
        <CardCollaboratorResume
          view={view}
          isOneCollaboratorResult={payPayrollData.payouts.length === 1}
          showDetailsCollaboratorUnique={showDetailsCollaboratorUnique}
          methodForPay={methodForPay}
          //deleteHandler={deleteHandler}
          collaborator={{
            ...(methodForPay === 'PSEPay'
              ? {
                  collaboratorBankAccountNumber: payPayrollData.payouts[0].bankAccountNumber,
                  collaboratorBankTypeAccount: accountSubTypeLabelObject[payPayrollData.payouts[0].bankAccountType],
                  collaboratorMoviiBankId: payPayrollData.payouts[0].bankIdMovii,
                  lastNameAccount: payPayrollData.payouts[0].bankAccountOwnerLastName,
                  bankAccountOwnerIdentificationType: payPayrollData.payouts[0].bankAccountOwnerIdentificationType,
                  bankAccountOwnerIdentificationNumber: payPayrollData.payouts[0].bankAccountOwnerIdentificationNumber,
                  name:
                    payPayrollData.payouts[0].bankAccountOwnerPersonTypeId === '2'
                      ? `${payPayrollData.payouts[0].bankAccountOwnerName} ${payPayrollData.payouts[0].bankAccountOwnerLastName}`
                      : payPayrollData.payouts[0].bankAccountOwnerBusinessName
                }
              : {}),

            statusDescription: payPayrollData.payouts[0].statusDescription,
            meloStatus: payPayrollData.payouts[0].meloStatus,
            receiverName: payPayrollData.payouts[0].receiverName,
            receiverLastName: payPayrollData.payouts[0].receiverLastName,
            metadata: payPayrollData.payouts[0].metadata,
            salaryToPay: payPayrollData.payouts[0].payedValue,
            receiverIdentificationType: payPayrollData.payouts[0].receiverIdentificationType,
            receiverIdentificationNumber: payPayrollData.payouts[0].receiverIdentificationNumber,
            salaryValue: payPayrollData.payouts[0].metadata.salaryValue,

            bankId: payPayrollData.payouts[0].bankId,
            bankAccountType: payPayrollData.payouts[0].bankAccountType,
            bankAccountNumber: payPayrollData.payouts[0].bankAccountNumber,
            bankAccountOwnerIdentificationType: payPayrollData.payouts[0].bankAccountOwnerIdentificationType,
            bankAccountOwnerIdentificationNumber: payPayrollData.payouts[0].bankAccountOwnerIdentificationNumber,
            name:
              payPayrollData.payouts[0].bankAccountOwnerPersonTypeId === '2'
                ? `${payPayrollData.payouts[0].bankAccountOwnerName} ${payPayrollData.payouts[0].bankAccountOwnerLastName}`
                : payPayrollData.payouts[0].bankAccountOwnerBusinessName
          }}
        />
      )}
      <div className={classes.origins}>
        <ResultOrigin
          methodForPay={methodForPay}
          origin={
            methodForPay === 'PSEPay'
              ? payPayrollData.psePayins.map(origin => ({
                  bankAccount: {
                    bankId: 'PSE',
                    name: origin.name,
                    endUser: {
                      identificationTypeLabel: documentTypesAbbreviationsObject[origin.identificationType],
                      identificationNumber: origin.identificationNumber
                    }
                  }
                }))
              : payPayrollData.druoPayments.map(origin => ({
                  value: origin.withdrawedValue,
                  bankAccount: {
                    bankId: origin.sourceBankDruoId,
                    subtypeLabel: origin.sourceBankAccountTypeLabel,
                    bankLast4Digits: `${origin.sourceBankAccountNumber}`,
                    name: origin.sourceBankOwnerName,
                    endUser: {
                      identificationTypeLabel: origin.sourceBankOwnerIdentificationTypeLabel,
                      identificationNumber: origin.sourceBankOwnerIdentificationNumber
                    }
                  }
                }))
          }
        />
      </div>
      <span className={`${classes.color} medium-16`}>{payPayrollData.totalCollaborators} colaboradores</span>
      <div className={classes.values}>
        <div className={classes['label-value']}>
          <div className={classes['label-icon']}>
            <span className='medium-16'>Costo de las transacciones</span>
            <Tooltip
              classNameChildren={classes.tooltip}
              position='bottom-left'
              content={`Una transacción es un movimiento que se realiza a una cuenta bancaria. Si haces pagos múltiples, estas son varias transacciones con un costo de ${utils.moneyFormat(
                payPayrollData.transactionsCost
              )} cada una.`}>
              <CircleExclamation />
            </Tooltip>
          </div>
          <span className='medium-16'>
            <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
              {utils.moneyFormat(payPayrollData.transactionsCost || (costTransaction * (payPayrollData.totalCollaborators || 1)))}
            </span>
          </span>
        </div>
        <div className={classes['label-value']}>
          <span className='medium-16'>Total de los colaboradores</span>
          <span className='medium-16'>{utils.moneyFormat(payPayrollData.subtotalValue)}</span>
        </div>
        <div className={classes['label-value']}>
          <span className='bold-20'>TOTAL</span>
          <span className='bold-20'>{utils.moneyFormat(payPayrollData.totalValue)}</span>
        </div>
      </div>
    </>
  );
};

export default CollaboratorsResult;
